import {BrowserRouter as Router, Route, Switch, Media} from 'react-router-dom';
import Wrapper from './components/Wrapper';
import Header from './components/Header'
import HoldingPage from './pages/HoldingPage';
import Homepage from './pages/Homepage';
import ProjectIndex from './pages/ProjectIndex';
import ProjectView from './pages/ProjectView';
import AboutPage from './pages/AboutPage';

const NoMatch = () => (
  <div className="fs pabs center" style={{
    background: '#FFFFFF',
    zIndex: 9999
  }}>
    404
  </div>
)

class FlyoverSwitch extends React.Component {

  previousLocation = this.props.location

  componentWillUpdate(nextProps) {
    const { location } = this.props
    // set previousLocation if props.location is not modal
    if (
      nextProps.history.action !== 'POP' &&
      (!location.state || !location.state.modal)
    ) {
      this.previousLocation = this.props.location
    }
  }

  render() {
    const { location } = this.props
    const isModal = !!(
      location.state &&
      location.state.modal &&
      this.previousLocation !== location // not initial render
    )
    return (
      <Wrapper>
        <Header />
        <Switch location={isModal ? this.previousLocation : location}>
          <Route exact path="/" component={Homepage} />
          <Route exact path="/projects" component={ProjectIndex} />
          <Route path="/project/:slug" component={ProjectView} />
          <Route exact path="/info" component={AboutPage} />
          <Route component={NoMatch} />
        </Switch>
        {isModal ? <Route path="/project/:slug" component={ProjectView} /> : null}
      </Wrapper>
    )
  }
}

const App = () => (
  <Router>
    <Route component={FlyoverSwitch} />
  </Router>
)

document.addEventListener("DOMContentLoaded", function() {
  ReactDOM.render(<App />, document.querySelector("[data-app]"));
});



// WEBPACK FOOTER //
// ./app/javascript/packs/application.js